import React, { useState } from 'react';
import cx from 'classnames';
import {
  BANNER_WIDGET_LAYOUT_TYPE_V2,
  BannerWidgetDetailV2,
  WidgetItemBannerItem,
} from '../../../../../../../types/widget';
import Img from '../../../../../../../components/Img/Img';
import Slider from '../../../../../../../components/utils/Slider/Slider';
import { BannerWidgetSwipeLayoutStyle } from './style';

export type BannerWidgetSwipeLayoutDetail = BannerWidgetDetailV2 & {
  layoutType:
    | typeof BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_1_DOT_5
    | typeof BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_2_DOT_5
    | typeof BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_MARGIN
    | typeof BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_NO_MARGIN;
};

interface BannerWidgetSwipeLayoutProps {
  detail: BannerWidgetSwipeLayoutDetail;
}
const BannerWidgetSwipeLayout = (props: BannerWidgetSwipeLayoutProps) => {
  const { detail } = props;
  const [float, setFloat] = useState('left');

  const SLIDE_TO_SHOW = {
    [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_1_DOT_5]: 1,
    [BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_2_DOT_5]: 2,
  } as Record<BANNER_WIDGET_LAYOUT_TYPE_V2, number>;

  const handleSwipe = (oldIndex: number, newIndex: number) => {
    setTimeout(() => {
      const offsetIndex = SLIDE_TO_SHOW[detail.layoutType] ? SLIDE_TO_SHOW[detail.layoutType] - 1 : 0;
      if (newIndex === detail.widgetItemBanners.length - 1 - offsetIndex) {
        setFloat('right');
      } else {
        setFloat('left');
      }
    }, 10);
  };

  const getSwipeProps = (type: BANNER_WIDGET_LAYOUT_TYPE_V2) => {
    switch (type) {
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_1_DOT_5:
        return {
          className: cx('swipe_1_dot_5', {
            'is-float-right': float === 'right',
            'is-float-left': float === 'left',
          }),
          beforeChange: handleSwipe,
          slidesToShow: SLIDE_TO_SHOW[type],
          dots: false,
        };
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_2_DOT_5:
        return {
          className: cx('swipe_2_dot_5', {
            'is-float-right': float === 'right',
            'is-float-left': float === 'left',
          }),
          beforeChange: handleSwipe,
          slidesToShow: SLIDE_TO_SHOW[type],
          dots: false,
        };
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_MARGIN:
        return { dots: true };
      case BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_NO_MARGIN:
        return { className: 'is-not-img-margin', dots: true };
    }
  };

  return (
    <BannerWidgetSwipeLayoutStyle>
      <Slider
        {...getSwipeProps(detail.layoutType)}
        emptyText={'홈에 노출 될 위젯 아이템 리스트 설정해주세요.'}
        list={detail.widgetItemBanners}
        arrows={false}
        infinite={false}
        item={(storeItem: WidgetItemBannerItem) => (
          <div className="widget-banner-section">
            <Img clickAble={false} src={storeItem.mobileImage?.[0]?.url} />
          </div>
        )}
      />
    </BannerWidgetSwipeLayoutStyle>
  );
};

export default BannerWidgetSwipeLayout;
